import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import Aux from '../../../hoc/Aux';
import * as messages from '../../../messages';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom'
import AudioRecorder from '../../AudioRecorder/AudioRecorder';
import Recorder from 'recorder-js';
import axios from '../../../axios-ns';
import Snackbar from '@material-ui/core/Snackbar';
import Spinner from '../../../components/UI/Spinner/Spinner';
import TextField from '@material-ui/core/TextField';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';

class CheckSong extends Component {

    state = {
        recordingStatus: null,
        recordingMaterialCode: 'CHECK_SONG',
        transactionCode: null,
        recorder: null,
        path: '',
        status: '',
        loading: true
    }

    componentDidMount() {
        axios.get('protected/transaction/' + this.props.match.params.transactionCode, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(response => {
                this.setState({ ...this.state, loading: false, status: response.data.evaluationStatus, report: response.data.report });
            }).catch(err => {

            })

        this.setState({
            ...this.state, transactionCode: this.props.match.params.transactionCode, materialCode: 'OU', recorder: new Recorder(new (window.AudioContext || window.webkitAudioContext)(), {
            })
        });

        navigator.mediaDevices.getUserMedia({ audio: true })
            .then(stream => {
                console.log("Initializing recorder");
                this.state.recorder.init(stream);

            })
            .catch(err => console.log('Uh oh... unable to get stream...', err));
    }

    onPathSend = () => {
        this.onAudioSend(this.state.materialCode, null);
    }

    onAudioSend = (materialCode, blob) => {
        const data = new FormData();
        data.append('sample', blob, 'testfile.wav');
        data.append('materialCode', materialCode);
        data.append('transactionCode', this.state.transactionCode);
        data.append('path', this.state.path);


        this.setState({ ...this.state, open: false }, () => {

            axios.post('protected/audio/analysis', data, { headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then(response => {
                    console.log("DASDAS");
                    this.setState({ ...this.state, status: 'WAITING_FOR_EVALUATION' });
                })
                .catch(err => { });
        });
    }

    handleError = (message) => {
        this.setState({
            ...this.state, message: message, showSnackbar: true, snackbarVariant: 'error', recorder: new Recorder(new (window.AudioContext || window.webkitAudioContext)(), {
            })
        }, () => {
            setTimeout(() => { document.location.reload(); }, 3000);
        });
    }

    handleChange = (event) => {
        this.setState({ ...this.state, path: event.target.value });
    }

    renderStars(score) {
        let fill = +score;
        let border = 5 - +score;
        let stars = Array(fill).fill(1).map(e => <StarIcon fontSize="small" style={{ color: 'orange' }} key={Math.random()} />);
        let borderStars = Array(border).fill(1).map(e => <StarBorderIcon fontSize="small" style={{ color: 'orange' }} key={Math.random()} />);
        return (<Aux>{stars}{borderStars}</Aux>);
    }

    renderSection(section, i) {
                return (<Card style={{marginBottom: '10px'}}>
                    <CardHeader
                        avatar={<Avatar aria-label="Recipe" style={{ backgroundColor: 'orange' }}>{i}</Avatar>}
                        title={<div><span style={{ float: 'left' }}>{messages[section + '_HEAD']}</span> <span style={{ float: 'right' }}>{this.renderStars(this.state.report[section + 'Score'])}</span></div>}
                    />
                    <Card style={{ margin: '5px', padding: '5px' }}>
                        <p style={{ fontSize: '10px', color: '#333' }}>
                            {messages[section + '_DESC']}
                    </p>
                        <p>
                            {this.state.report[section + 'Description']}
                        </p>

                        {/* <p style={{ fontSize: '10px', color: '#333' }}>
                            Jak możesz poprawić się w tym obszarze?
                    </p>
                        <p>
                        {messages[section + '_SOL']}
                    </p> */}
                    </Card>
                </Card>);

    }

    render() {
        let view = this.state.recorder && this.state.report == null ? (<Card style={{ padding: '10px' }}>
            <p>
                Cześć!<br /><br />
                Chwila prawdy przed Tobą:) Jak to będzie wyglądało.<br /><br />

                Masz dwie możliwości:<br /><br />
                Możesz przesłać swoje nagranie, które masz udostępnione gdzieś w internecie. W tym celu w polu poniżej wpisz adres pod którym kryje się Twoje nagranie i kliknij przycisk "Wyślij".
                <br /><br />
                Opcja druga, dla prawdziwych <b>twardzieli</b>, to nagranie na żywo! W tym celu skorzystaj z poniższego rejestratora dźwięku.<br /><br />
                Po wysłaniu nagrań, w przeciągu max dwóch dni roboczych otrzymasz wiadomość email z informacją, że Twoje nagranie zostało już ocenione. Zaloguj się wtedy na platformę, otwórz usługę i zobaczysz tam
                szczegółowy wynik analizy Twojego utworu.<br /><br />
                Gotów na wyzwanie? Zaczynamy!
            </p>
            <CardHeader
                avatar={
                    <Avatar aria-label="Recipe" style={{ backgroundColor: 'orange' }}>
                        1
                    </Avatar>
                }
                title="Prześlij link do swojego nagrania"
            />
            <p>
                Jeśli posiadasz nagranie udostepnione w internecie, wpisz / wklej poniżej jego adres.
                <TextField
                    id="outlined-multiline-flexible"
                    label="Twoje nagranie"
                    rowsMax="1"
                    style={{ width: '500px' }}
                    value={this.state.path}
                    onChange={(event) => this.handleChange(event, 'message')}
                    margin="normal"
                    helperText="Podaj proszę ścieżkę do swojego nagrania"
                /><br />
                <Button color="primary" style={{ marginLeft: '10px' }} disabled={this.state.path == 0 ? true : false} onClick={this.onPathSend}>
                    Prześlij swoje nagranie</Button>
            </p>

            <CardHeader
                avatar={
                    <Avatar aria-label="Recipe" style={{ backgroundColor: 'orange' }}>
                        2
                    </Avatar>
                }
                title="Nagraj się na żywo"
            />

            <p>
                Jeśli nie posiadasz nagrania - nie ma problemu. Możesz się nagrać w tej chwili i wysłać nagranie do oceny. Nagranie może trwać maksymalnie 4 minuty.
            <AudioRecorder materialCode={this.state.recordingMaterialCode} maxTime={240} onSend={this.onAudioSend} handleError={this.handleError} recorder={this.state.recorder} />
            </p>
            <Snackbar open={this.state.showSnackbar} anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
                autoHideDuration={3000}
                onClose={this.onSnackbarClose}
                variant={this.state.snackbarVariant}
                bodyStyle={{ backgroundColor: 'red' }}
                message={<span dangerouslySetInnerHTML={{ __html: this.state.message }}></span>} />

        </Card >) : null;

        if (this.state.status == 'WAITING_FOR_EVALUATION') {
            view = (<Card style={{ padding: '10px' }}>
                Twoje nagranie zostało przekazane do oceny. W chwili gdy raport będzie gotowy otrzymasz powiadomienie drogą mailową.
            </Card>);
        } else if (this.state.report && this.state.status == 'EVALUATED') {

            view = (<Card style={{ padding: '10px', color: '#777' }}>
                <p style={{ textAlign: 'center' }}>
                    <h1>Analiza Utworu Wokalnego</h1>
                </p>
                <p style={{textAlign: 'left', marginLeft: '30px', marginRight: '30px'}}>
                <span >Oceniający:</span> <b style={{float: 'right'}}>Karina Majewska</b><br/>
                <span >Data:</span> <b style={{float: 'right'}}>{this.state.report.evaluationDate}</b><br/>
                <span >Suma punktów:</span> <b style={{float: 'right'}}>{this.state.report.totalScore} / 35</b>
                </p>
                <p style={{borderTop: '1px solid orange', borderBottom: '1px solid orange', padding: '10px'}}>Poniżej znajdziesz szczegółową ocenę swojego nagrania w siedmu, kluczowych aspektach. Za każdy z nich możesz zdobyć maksymalnie pięć punktów. </p>
                {["intonation", "rythm", "interpretation", "diction", "musicality", "vocalTech", "genericArtistFace"].map((e, i) => this.renderSection(e, ++i))}
                <p style={{borderTop: '1px solid orange', borderBottom: '1px solid orange', padding: '10px'}}>Mam nadzieję, że powyższa analiza okaże się dla Ciebie przydatna i pozwoli Ci skoncentrować wysiłki na obszarach wymagających większej uwagi. Całą masę ćwiczeń dla wskazanych obszarów możesz znaleźć w moim Poradniku Wokalisty, dostępnym z poziomu aplikacji. Teraz możesz go nabyć 20zł taniej, wykorzystując kod zniżkowy <b>RABAT</b>.</p>
            </Card>);
        }

        if(this.state.loading) {
            view = <Spinner/>;
        }

        return view;

    };
}

export default CheckSong;